import { LogOut, ChevronDown, Clock } from 'lucide-react';
import {
  SegmentedControl,
  Avatar,
  AvatarFallback,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/shared/ui';
import { useAppStore } from '@/shared/store/app-store';
import { useAuthStore } from '@/features/auth/auth-store';
import { TIME_WINDOWS } from './nav';

export function TimeRangeSelector() {
  const window = useAppStore((s) => s.window);
  const setWindow = useAppStore((s) => s.setWindow);
  return (
    <div className="flex items-center gap-1.5">
      <Clock className="size-3.5 text-faint" aria-hidden />
      <SegmentedControl
        ariaLabel="Time range"
        options={TIME_WINDOWS}
        value={window}
        onChange={setWindow}
      />
    </div>
  );
}

export function UserMenu() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const initials = (user?.name ?? 'U')
    .split(' ')
    .map((p) => p[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 rounded-md p-1 pr-2 transition-colors hover:bg-surface-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
        <Avatar>
          <AvatarFallback>{initials}</AvatarFallback>
        </Avatar>
        <div className="hidden text-left leading-tight sm:block">
          <div className="text-xs font-medium text-foreground">{user?.name ?? 'User'}</div>
          <div className="text-[11px] text-faint">{user?.role ?? '—'}</div>
        </div>
        <ChevronDown className="size-3.5 text-faint" aria-hidden />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{user?.email}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => void logout()}>
          <LogOut />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
